import type {WarehouseGridPdfDefinition} from '../types/WarehouseGridPdfDefinition';

function withColumns(definition: WarehouseGridPdfDefinition) {
  return {
    ...definition,
    columns: [...definition.header, ...definition.groups.flat()].map((field) => field.key),
  };
}

/** Fixed export contracts, verified against the warehouse grid definitions. */
export const WAREHOUSE_PDF_DEFINITIONS = {
  deliveryNotes: withColumns({
    filename: 'delivery-notes.pdf',
    header: [
      {key: 'deliveryNoteNo', kind: 'text'},
      {key: 'state', kind: 'label'},
      {key: 'deliverySource', kind: 'label'},
    ],
    groups: [
      [
        {key: 'supplier', kind: 'label'},
        {key: 'warehouse', kind: 'label'},
        {key: 'purchaseValue', kind: 'money'},
      ],
      [
        {key: 'createdAt', kind: 'dateTime'},
        {key: 'createdBy', kind: 'label'},
        {key: 'receiveNoteNo', kind: 'label'},
      ],
      [
        {key: 'completedAt', kind: 'dateTime'},
        {key: 'completedBy', kind: 'label'},
      ],
    ],
  }),
  articles: withColumns({
    filename: 'warehouse-articles.pdf',
    header: [
      {key: 'catalogNumber', kind: 'text'},
      {key: 'name', kind: 'text'},
      {key: 'manufacturerId', kind: 'label'},
      {key: 'warehouseId', kind: 'label'},
    ],
    groups: [
      [
        {key: 'spaceStorageLocation', kind: 'text'},
        {key: 'stockQuantity', kind: 'number'},
        {key: 'availableQuantity', kind: 'number'},
        {key: 'reservedQuantity', kind: 'number'},
      ],
      [
        {key: 'salePriceWithVat', kind: 'money'},
        {key: 'avgPurchasePrice', kind: 'money'},
        {key: 'lastPurchasePrice', kind: 'money'},
      ],
    ],
  }),
  transfers: withColumns({
    filename: 'warehouse-transfers.pdf',
    header: [
      {key: 'transferOrderNumber', kind: 'text'},
      {key: 'state', kind: 'label'},
      {key: 'sourceWarehouse', kind: 'label'},
      {key: 'destinationWarehouse', kind: 'label'},
    ],
    groups: [
      [
        {key: 'createdAt', kind: 'dateTime'},
        {key: 'createdBy', kind: 'label'},
        {key: 'sentAt', kind: 'dateTime'},
        {key: 'sentBy', kind: 'label'},
      ],
      [
        {key: 'receivedAt', kind: 'dateTime'},
        {key: 'receivedBy', kind: 'label'},
      ],
    ],
  }),
  supplierOrders: withColumns({
    filename: 'supplier-orders.pdf',
    header: [
      {key: 'number', kind: 'text'},
      {key: 'state', kind: 'label'},
      {key: 'supplier', kind: 'label'},
      {key: 'warehouse', kind: 'text'},
    ],
    groups: [
      [
        {key: 'created', kind: 'dateTime'},
        {key: 'createdBy', kind: 'text'},
        {key: 'totalValueWithoutVat', kind: 'money'},
      ],
      [
        {key: 'sent', kind: 'dateTime'},
        {key: 'sentBy', kind: 'text'},
      ],
      [{key: 'note', kind: 'text', share: 4}],
    ],
  }),
  purchaseList: withColumns({
    filename: 'warehouse-purchase-list.pdf',
    header: [
      {key: 'catalogNumber', kind: 'text'},
      {key: 'name', kind: 'text'},
      {key: 'manufacturerId', kind: 'label'},
      {key: 'quantity', kind: 'number'},
    ],
    groups: [
      [
        {key: 'warehouseId', kind: 'label'},
        {key: 'supplierId', kind: 'label', share: 2},
        {key: 'neededAt', kind: 'date'},
      ],
      [
        {key: 'created', kind: 'dateTime'},
        {key: 'requestSourceCreatedBy', kind: 'text'},
        {key: 'serviceOrderNumber', kind: 'text'},
        {key: 'directSaleNumber', kind: 'text'},
      ],
    ],
  }),
};
